import React from "react";
import { withRouter } from "react-router";

import { NavLink } from "react-router-dom";

import IntelligenceDateTab from "./intelligenceDateTab";
import SideContentInner from "../../../shared/sideContentInner";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";

import styles from "./intelligenceCarsNavbar.module.scss";
import { withIntelligenceControl } from "../../../shared/containers/containerIntelligenceControl";

const getPath = (props) => {
  const { match } = props;

  switch (match.path) {
    case "/cars/:id/inmoment":
      sessionStorage.setItem("intelligenceRangeType", "inmoment");
      return "inmoment";
    case "/cars/:id/intimerange":
      sessionStorage.setItem("intelligenceRangeType", "intimerange");
      return "intimerange";
    default:
      return !!sessionStorage.getItem("intelligenceRangeType") ? sessionStorage.getItem("intelligenceRangeType") : "intimerange";
  }
};

const IntelligenceCarsNavbar = (props) => {
  const { match } = props;
  const carId = match.params.id;
  let rangeType = getPath(props);

  const { onSetFullScreen, fullScreen } = props;

  return (
    <div className={styles.intelligenceCarsNavbar}>
      <SideContentInner>
        <div className={styles.tabs_container}>
          <div className={styles.tab_container}>
            <NavLink exact activeClassName={styles.tab_active} className={styles.tab} to={`/cars/${carId}/${rangeType}`}>
              <IntelligenceDateTab />
            </NavLink>
          </div>
  {/*         <div className={styles.tab_container}>
            <NavLink exact activeClassName={styles.tab_active} className={styles.tab} to={`/cars/${carId}`}>
              Информация
            </NavLink>
          </div> */}

          <div className={styles.tab_container_screen}>
            <div
              onClick={() => {
                onSetFullScreen(!fullScreen);
              }}
            >
              <TooltipWrapper title={fullScreen ? "Свернуть панель сведений" : "Развернуть панель сведений"} position="left">
                {fullScreen ? <FullscreenExitIcon fontSize="small" /> : <FullscreenIcon fontSize="small" />}
              </TooltipWrapper>
            </div>
          </div>
        </div>
      </SideContentInner>
    </div>
  );
};

export default withIntelligenceControl(withRouter(IntelligenceCarsNavbar));
